import { useQuery, useMutation } from 'react-query'
import API, { useGetInfinite } from '.'

const ENDPOINT = '/api/warranty'
const QUERY_KEY = 'warranty'

export const useGetWarrantyRegistration = (id, config = {}) =>
  useQuery([QUERY_KEY, 'detail', id], async () => (await API.get(`${ENDPOINT}/${id}`)).data, config)

export const useGetWarrantyRegistrations = (params) =>
  useQuery(
    [QUERY_KEY, 'list', params],
    async () => (await API.get(`${ENDPOINT}?${new URLSearchParams(params).toString()}`)).data
  )

export const useCreateWarrantyRegistration = (config = {}) =>
  useMutation((data) => API.post(ENDPOINT, data), config)

export const useDeleteWarrantyRegistration = (config = {}) =>
  useMutation((id) => API.delete(`${ENDPOINT}/${id}`), config)

export const useGetWarrantyRegistrationsInfinite = (params = {}, config = {}) =>
  useGetInfinite({ key: QUERY_KEY, endpoint: ENDPOINT, params, config })

export const useExportWarrantyRegistration = (config = {}) =>
  useMutation(
    (data) =>
      API.get(`${ENDPOINT}/export-warranty-registration?${new URLSearchParams(data).toString()}`, {
        responseType: 'blob',
      }),
    config
  )
